module.exports = __webpack_public_path__ + "media/images/red_ball-742dc8f57a7afdb77608bbc96d422efe.gif";